
/**
 * Adds 'name' prop equal to key for redux-forms
 * Adds key prop for array usage in react
 * @param {object} field 
 * @returns {object} field 
 */
export default function bindName(field, key) {
  return { ...field, key, name: key };
}